<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">User in course</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow>
            <div style="margin-left:15px;">
              <h3>Section {{ userInCourse.courseDetail[0].code }}</h3>
            </div>
          </CRow>
          <CRow style="margin-top:20px">
            <CCol>
              <CChartPie
                :datasets="defaultDatasets"
                :labels="[
                  setUser('enroll'),
                  setUser('completed'),
                  setUser('unenrolled'),
                ]"
              />
            </CCol>
            <CCol>
              <CChartPie
                :datasets="defaultDatasets2"
                :labels="[setUserType('mfu'), setUserType('mdl')]"
              />
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
import { CChartPie } from "@coreui/vue-chartjs";
import { mapGetters } from "vuex";

export default {
  name: "userInCourse",
  components: {
    CChartPie,
  },
  props: {
    userInCourse: Object,
  },
  data() {
    return {
      defaultDatasets: [],
      defaultDatasets2: [],
      totalCompleted: 0,
      totalUnenrolled: 0,
      totalInprogress: 0,
      mdlUser: 0,
      mfuUser: 0,
      otherUser: 0,
    };
  },
  mounted() {},
  created() {
    this.seperateUserType();
    this.seperateUserCourseStatus();
    this.setFirstPiData();
    this.setSecondPiData();
  },
  computed: {},
  watch: {
    userInCourse: function() {
      this.seperateUserType();
      this.seperateUserCourseStatus();
      this.setFirstPiData();
      this.setSecondPiData();
    },
  },
  methods: {
    setFirstPiData() {
      this.defaultDatasets = [
        {
          backgroundColor: [ "#FFE4E1","#FF6633", "#FFCCCC"],
          data: [
            this.totalInprogress,
            this.totalCompleted,
            this.totalUnenrolled,
          ],
        },
      ];
    },
    setSecondPiData() {
      this.defaultDatasets2 = [
        {
          backgroundColor: ["#FF6633", "#FFCCCC"],
          data: [this.mfuUser, this.mdlUser],
        },
      ];
    },
    setUser(type) {
      if (type == "enroll") {
        return "user in progress ( " + this.totalInprogress + " User) ";
      } else if (type == "completed") {
        return "user completed ( " + this.totalCompleted + " User) ";
      } else if (type == "unenrolled") {
        return "user unenrolled ( " + this.totalUnenrolled + " User) ";
      } else {
        // alert('Something went wrong, please contact the administrator.')
      }
    },
    setUserType(type) {
      if (type == "mfu") {
        return "MFU ( " + this.mfuUser + " User) ";
      } else if (type == "mdl") {
        return "MDL ( " + this.mdlUser + " User) ";
      }
    },
    seperateUserType() {
      this.mdlUser = 0;
      this.mfuUser = 0;
      for (let i = 0; i < this.userInCourse.userDetail.length; i++) {
        // if (this.userInCourse.userDetail[i].userId.userType == 10) {
        if (this.userInCourse.userDetail[i].userType == 10 || 99) {
          this.mfuUser += 1;
        }
      }
      this.mdlUser = this.userInCourse.userDetail.length - this.mfuUser;
    },
    seperateUserCourseStatus() {
      this.totalCompleted = 0;
      this.totalUnenrolled = 0;
      this.totalInprogress = 0;
      for (
        let i = 0;
        i < this.userInCourse.courseDetail[0].studentEnroll.length;
        i++
      ) {
        if (
          this.userInCourse.courseDetail[0].studentEnroll[i].complete == true
        ) {
          this.totalCompleted += 1;
        } else if (
          this.userInCourse.courseDetail[0].studentEnroll[i].unenroll == true
        ) {
          this.totalUnenrolled += 1;
        }
      }
      
      this.totalInprogress =
        this.userInCourse.courseDetail[0].studentEnroll.length -
        (this.totalCompleted + this.totalUnenrolled);
    },
  },
};
</script>
